export default __webpack_public_path__ + "static/media/img-0801-greece-half-face.3d301cb2.png";